import { render, staticRenderFns } from "./portefeuilleConfie.vue?vue&type=template&id=346a26da&"
import script from "./portefeuilleConfie.vue?vue&type=script&lang=js&"
export * from "./portefeuilleConfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports